module.exports = __webpack_public_path__ + "img/mc-dark.a7d73ee.svg";